
const digest = '264d924d2d24cc9f154c97355ce499f0e5a27faa26b05103ab9a0f283c62823e';
const classes = {"container":"_container_qidgk_1","box":"_box_qidgk_5","list":"_list_qidgk_22","tag":"_tag_qidgk_31","input":"_input_qidgk_46","section":"_section_qidgk_57","sectionFooter":"_sectionFooter_qidgk_61","sectionName":"_sectionName_qidgk_65","showMoreLess":"_showMoreLess_qidgk_74"};
const css = `._container_qidgk_1 {
  position: relative;
}

._box_qidgk_5 {
  border: 1px solid #e2e5ed;
  min-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 16px 20px !important;
  background: #ffffff;
}
._box_qidgk_5:focus-within {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
}

._list_qidgk_22 {
  border: 1px solid #1452ac;
  border-radius: 30px;
  position: absolute;
  z-index: 999;
  width: 100%;
  background: #fff;
}

._tag_qidgk_31 {
  border-radius: 30px;
  display: inline-block;
  line-height: 26px;
  border: 1px solid #d81616;
  background: #fff;
  color: #000;
  height: 29px;
  padding: 2px 10px;
  margin-bottom: 5px;
}
._tag_qidgk_31 + ._tag_qidgk_31 {
  margin-left: 5px;
}

._input_qidgk_46 {
  border: none;
  box-shadow: none;
  outline: 0;
  background-color: transparent;
  padding: 0 6px;
  margin: 0;
  width: 100%;
  max-width: inherit;
}

._section_qidgk_57 + ._section_qidgk_57 {
  border-top: 1px solid #eaedf3;
}

._sectionFooter_qidgk_61 {
  padding: 0 20px 20px;
}

._sectionName_qidgk_65 {
  font-family: Rubik, sans-serif;
  text-transform: uppercase;
  color: #9ea0a5;
  letter-spacing: 2px;
  font-size: 12px;
  padding: 20px 20px 0;
}

._showMoreLess_qidgk_74 {
  font-family: Rubik, sans-serif;
  color: #1665d8;
  font-size: 12px;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  